import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api';

export default function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');

  const [loading, setLoading]   = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await axios.post('/auth/login', { username, password });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('userId', res.data.userId);
      localStorage.setItem('userName', res.data.name);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    }
    setLoading(false);
  };

  // Card style for glass effect
  const cardStyle = {
    background: 'rgba(255,255,255,0.83)',
    border: '1.5px solid #d9e6f7',
    borderRadius: '1.7rem',
    boxShadow: '0 10px 40px 0 rgba(60,80,180,0.10)',
    backdropFilter: 'blur(7px)',
    padding: '2.6rem 1.8rem 2rem 1.8rem',
    width: '100%',
    maxWidth: '360px',
    margin: '0 auto'
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center min-vh-100"
      style={{
        background: 'linear-gradient(120deg, #c2e9fb 0%, #81a4fd 100%)',
      }}
    >
      <div
        className="card"
        style={cardStyle}
      >
        <div className="text-center mb-4">
          <div
            style={{
              width: 70,
              height: 70,
              margin: '0 auto 1.2rem',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #b3d8ff 30%, #6fa8f7 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 15px #b3d8ff66',
            }}
          >
            <span style={{ fontSize: 38, color: '#3561b6' }}>🧑‍💼</span>
          </div>
          <h2 className="fw-bold mb-1" style={{ letterSpacing: 1, color: '#3764b2' }}>
            GST Invoice Login
          </h2>
          <div className="text-muted mb-2 small" style={{ letterSpacing: 0.6 }}>Secure Admin Access</div>
        </div>

        {error && (
          <div className="alert alert-danger py-2 animate__animated animate__fadeIn mb-3" style={{ fontSize: 14 }}>
            {error}
          </div>
        )}

        <form onSubmit={handleLogin} autoComplete="off">
          <div className="mb-3">
            <label className="form-label fw-semibold" style={{ color: '#41619b' }}>Username</label>
            <input
              type="text"
              required
              className="form-control rounded-3 px-3"
              style={{ background: '#f5fafd' }}
              placeholder="Enter your username"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold" style={{ color: '#41619b' }}>Password</label>
            <input
              type="password"
              required
              className="form-control rounded-3 px-3"
              style={{ background: '#f5fafd' }}
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button
            className="btn btn-primary w-100 rounded-pill mt-2"
            type="submit"
            disabled={loading}
            style={{ fontWeight: 600, fontSize: 16, letterSpacing: 0.5, boxShadow: '0 2px 10px #81a4fd33' }}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}
